/*
* HoC that injects invoicable jobs as the `jobs` property.
 */
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, withProps } from 'recompose';


import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';


export const JobOverview = gql`
  fragment JobOverview on Job {
    id
    accountingState: accounting_state
    approvedAt: approved_at {
      month
      day
    }
    ticketCount: ticket_count
    invoiceState: invoice_state
    jobNumber: job_number
    hasUnreviewReasons: has_unreview_reasons
    jobUnreviewReasons: job_unreview_reasons {
      id
      unreviewed_by {
        id
        fullname
      }
      reason
    }
    lease {
      id
      name
    }
    mostRecentTicket: most_recent_ticket {
      id
      date {
        month
        day
      }
    }
    departments {
      edges {
        node {
          id
          name
        }
      }
    }
    pdf_path
  }
`;


export const JobInvoiceableInbox = gql`
  query JobInvoiceableInbox {
    jobs_for_approval_inbox {
      edges {
        node {
          ...JobOverview
        }
      }
    }
  }
  ${JobOverview}
`;


const mapDataToProps = withProps((props) => {
  const { data } = props;
  const tempResults = querySelector(data, '$.jobs_for_approval_inbox.edges[*].node', []);

  const jobs = tempResults.map((item) => {
    const copyObject = Object.assign({}, item);
    const deptObjectNames = querySelector(item, '$.departments.edges[*].node.name');

    copyObject.allDepartments = deptObjectNames.join(', ');
    copyObject.approvedDate = `${item.approvedAt.month}/${item.approvedAt.day}`;
    copyObject.leaseName = item.lease.name;
    copyObject.mostRecentTicketDate = `${item.mostRecentTicket.date.month}/${item.mostRecentTicket.date.day}`;
    return copyObject;
  });

  const { loading } = data;
  return {
    jobs,
    loading,
  };
});


const withData = graphql(JobInvoiceableInbox, {
  options: {
    fetchPolicy: 'network-only',
    pollInterval: 1000 * 60,
    queryDeduplication: true,
  },
});


const enhance = compose(
  withData,
  queryMetaHandler,
  mapDataToProps,
  omitProps(['data']),
);


export default enhance;
